import React from "react";
import ReactDOM from "react-dom/client";
import "@/index.css";
import App from "@/App";
import ErrorBoundary from "@/components/ErrorBoundary";

// Apply dark theme to HTML element
document.documentElement.classList.add('dark');

// Auto-reload page when service worker pushes a new bundle (post-deploy cache bust)
if ('serviceWorker' in navigator) {
  navigator.serviceWorker.addEventListener('message', (ev) => {
    if (ev?.data?.type === 'SW_UPDATED') {
      try {
        const last = sessionStorage.getItem('sw_reloaded_at');
        // Only auto-reload at most once per session to avoid loops
        if (!last || Date.now() - Number(last) > 60_000) {
          sessionStorage.setItem('sw_reloaded_at', String(Date.now()));
          window.location.reload();
        }
      } catch (_) { window.location.reload(); }
    }
  });
  // On controllerchange (new SW took over), reload once
  let _reloaded = false;
  navigator.serviceWorker.addEventListener('controllerchange', () => {
    if (_reloaded) return;
    _reloaded = true;
    window.location.reload();
  });
}

// Expose build version so users can SEE which bundle they have (for support)
window.__ANANT_BUILD__ = '2026-06-30T21:30';

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <ErrorBoundary>
      <App />
    </ErrorBoundary>
  </React.StrictMode>,
);
